module.exports = __webpack_public_path__ + "img/banner_rank_history.19065084.png";